import { deepmerge } from 'utilities/merge'
export interface IMouseDragUtilOptions {
  onDrag?: () => void,
  onEnd?: () => void,
  unitX?: number,
  unitY?: number
}
export interface IMouseDragUtilPosition {
  x: number,
  y: number,
  stepX: number,
  stepY: number
}
export class MouseDragUtil {
  public intervalId: number;
  public mouseupEvent:   (e:MouseEvent) => void;
  public mousemoveEvent: (e:MouseEvent) => void;
  public dragCallback: () => void;
  public endCallback:  () => void;
  public startX: number;
  public startY: number;
  public currentX: number;
  public currentY: number;
  public stepX: number = 0;
  public stepY: number = 0;
  public defaultOptions: IMouseDragUtilOptions = {
    onDrag: () => {},
    onEnd: () => {},
    unitX: 1,
    unitY: 1
  };
  public options:IMouseDragUtilOptions = {}
  constructor(startMouseEvent: MouseEvent, options:IMouseDragUtilOptions = {}){
    this.options  = deepmerge(this.defaultOptions, options);
    this.startX   = startMouseEvent.pageX;
    this.startY   = startMouseEvent.pageY;
    this.currentX = startMouseEvent.pageX;
    this.currentY = startMouseEvent.pageY;
    this.mouseupEvent   = (e:MouseEvent) => { this.onMouseUp(e); }
    this.mousemoveEvent = (e:MouseEvent) => { this.onMouseMove(e); }
    this.dragCallback = this.options.onDrag;
    this.endCallback  = this.options.onEnd;
    window.addEventListener('mouseup', this.mouseupEvent);
    window.addEventListener('mousemove', this.mousemoveEvent);
  }
  onMouseUp(e:MouseEvent): void{
    this.setCurrentPosition(e);
    window.removeEventListener('mouseup',   this.mouseupEvent);
    window.removeEventListener('mousemove', this.mousemoveEvent);
    this.endCallback()
  }
  onMouseMove(e:MouseEvent): void{
    let stepX = this.stepX + 0;
    let stepY = this.stepY + 0;
    this.setCurrentPosition(e);
    if(this.stepX != stepX || this.stepY != stepY){
      this.dragCallback();
    }
  }
  setCurrentPosition(e:MouseEvent): void{
    this.currentX = e.pageX;
    this.currentY = e.pageY;
    if(this.options.unitX == 0){
      this.stepX = 0;
    } else {
      this.stepX = Math.floor(this.x() / this.options.unitX);
    }
    if(this.options.unitY == 0){
      this.stepY = 0;
    } else {
      this.stepY = Math.floor(this.y() / this.options.unitY);
    }
  }
  x(): number{
    return this.currentX - this.startX;
  }
  y(): number{
    return this.currentY - this.startY;
  }
  pos(): IMouseDragUtilPosition{
    return {x: this.x(), y: this.y(), stepX: this.stepX, stepY: this.stepY };
  }
}
